import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const ComparisonSection = () => {
  const [currentLanguage, setCurrentLanguage] = useState('en');

  const translations = {
    en: {
      title: "How We Compare",
      subtitle: "See why AlumERP offers the best value for aluminum manufacturers",
      competitors: {
        alumerp: "AlumERP",
        competitor1: "Generic ERP A",
        competitor2: "Generic ERP B",
        competitor3: "Custom Solution"
      },
      features: [
        {
          category: "Pricing & Value",
          items: [
            {
              feature: "Transparent Pricing",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "No Hidden Costs",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "30-Day Free Trial",
              alumerp: true,
              competitor1: false,
              competitor2: true,
              competitor3: false
            },
            {
              feature: "Money-Back Guarantee",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        },
        {
          category: "Industry Specialization",
          items: [
            {
              feature: "Aluminum-Specific Features",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: "partial"
            },
            {
              feature: "Extrusion Process Management",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: "partial"
            },
            {
              feature: "Quality Control for Aluminum",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "Industry Best Practices",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        },
        {
          category: "Support & Implementation",
          items: [
            {
              feature: "24/7 Local Support",
              alumerp: true,
              competitor1: "partial",
              competitor2: false,
              competitor3: false
            },
            {
              feature: "Free Data Migration",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "Dedicated Account Manager",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: true
            },
            {
              feature: "Industry Expert Training",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        }
      ],
      totalCost: {
        title: "Total Cost of Ownership (3 Years)",
        alumerp: "₹10,80,000",
        competitor1: "₹18,50,000",
        competitor2: "₹15,20,000",
        competitor3: "₹25,00,000",
        savings: "Save up to ₹14,20,000"
      },
      legend: {
        included: "Included",
        notIncluded: "Not Included",
        partial: "Partial/Extra Cost"
      }
    },
    hi: {
      title: "हम कैसे तुलना करते हैं",
      subtitle: "देखें कि AlumERP एल्यूमीनियम निर्माताओं के लिए सबसे अच्छा मूल्य क्यों प्रदान करता है",
      competitors: {
        alumerp: "AlumERP",
        competitor1: "जेनेरिक ERP A",
        competitor2: "जेनेरिक ERP B",
        competitor3: "कस्टम समाधान"
      },
      features: [
        {
          category: "मूल्य निर्धारण और मूल्य",
          items: [
            {
              feature: "पारदर्शी मूल्य निर्धारण",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "कोई छुपी हुई लागत नहीं",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "30-दिन मुफ्त ट्रायल",
              alumerp: true,
              competitor1: false,
              competitor2: true,
              competitor3: false
            },
            {
              feature: "पैसे वापसी की गारंटी",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        },
        {
          category: "उद्योग विशेषज्ञता",
          items: [
            {
              feature: "एल्यूमीनियम-विशिष्ट सुविधाएं",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: "partial"
            },
            {
              feature: "एक्सट्रूज़न प्रक्रिया प्रबंधन",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: "partial"
            },
            {
              feature: "एल्यूमीनियम के लिए गुणवत्ता नियंत्रण",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "उद्योग सर्वोत्तम प्रथाएं",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        },
        {
          category: "सहायता और कार्यान्वयन",
          items: [
            {
              feature: "24/7 स्थानीय सहायता",
              alumerp: true,
              competitor1: "partial",
              competitor2: false,
              competitor3: false
            },
            {
              feature: "मुफ्त डेटा माइग्रेशन",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            },
            {
              feature: "समर्पित खाता प्रबंधक",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: true
            },
            {
              feature: "उद्योग विशेषज्ञ प्रशिक्षण",
              alumerp: true,
              competitor1: false,
              competitor2: false,
              competitor3: false
            }
          ]
        }
      ],
      totalCost: {
        title: "कुल स्वामित्व लागत (3 वर्ष)",
        alumerp: "₹10,80,000",
        competitor1: "₹18,50,000",
        competitor2: "₹15,20,000",
        competitor3: "₹25,00,000",
        savings: "₹14,20,000 तक बचाएं"
      },
      legend: {
        included: "शामिल",
        notIncluded: "शामिल नहीं",
        partial: "आंशिक/अतिरिक्त लागत"
      }
    }
  };

  const t = translations[currentLanguage];

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage) {
      setCurrentLanguage(savedLanguage);
    }
  }, []);

  const renderCheckmark = (value) => {
    if (value === true) {
      return <Icon name="Check" size={20} color="var(--color-success)" />;
    } else if (value === false) {
      return <Icon name="X" size={20} color="var(--color-error)" />;
    } else if (value === "partial") {
      return <Icon name="Minus" size={20} color="var(--color-warning)" />;
    }
  };

  return (
    <section id="comparison" className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-6">
            {t.title}
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-white rounded-2xl shadow-lg border border-border overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              {/* Header */}
              <thead className="bg-surface-50">
                <tr>
                  <th className="px-6 py-4 text-left text-sm font-semibold text-gray-900">
                    {currentLanguage === 'en' ? 'Features' : 'सुविधाएं'}
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-primary bg-primary-50">
                    {t.competitors.alumerp}
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                    {t.competitors.competitor1}
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                    {t.competitors.competitor2}
                  </th>
                  <th className="px-6 py-4 text-center text-sm font-semibold text-gray-900">
                    {t.competitors.competitor3}
                  </th>
                </tr>
              </thead>

              <tbody>
                {t.features.map((category, categoryIndex) => (
                  <React.Fragment key={categoryIndex}>
                    {/* Category Header */}
                    <tr className="bg-surface-100">
                      <td colSpan="5" className="px-6 py-3 text-sm font-semibold text-gray-900">
                        {category.category}
                      </td>
                    </tr>
                    
                    {/* Category Items */}
                    {category.items.map((item, itemIndex) => (
                      <tr key={itemIndex} className="border-b border-surface-200 hover:bg-surface-50">
                        <td className="px-6 py-4 text-sm text-gray-900">
                          {item.feature}
                        </td>
                        <td className="px-6 py-4 text-center bg-primary-25">
                          {renderCheckmark(item.alumerp)}
                        </td>
                        <td className="px-6 py-4 text-center">
                          {renderCheckmark(item.competitor1)}
                        </td>
                        <td className="px-6 py-4 text-center">
                          {renderCheckmark(item.competitor2)}
                        </td>
                        <td className="px-6 py-4 text-center">
                          {renderCheckmark(item.competitor3)}
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Legend */}
        <div className="flex justify-center mt-8">
          <div className="flex items-center space-x-8 text-sm">
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} color="var(--color-success)" />
              <span className="text-text-secondary">{t.legend.included}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="X" size={16} color="var(--color-error)" />
              <span className="text-text-secondary">{t.legend.notIncluded}</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Minus" size={16} color="var(--color-warning)" />
              <span className="text-text-secondary">{t.legend.partial}</span>
            </div>
          </div>
        </div>

        {/* Total Cost Comparison */}
        <div className="mt-16 bg-gradient-to-r from-primary-50 to-accent-50 rounded-2xl p-8">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold text-primary mb-4">
              {t.totalCost.title}
            </h3>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl p-6 shadow-lg border-2 border-primary">
              <div className="text-center">
                <div className="text-sm text-text-secondary mb-2">{t.competitors.alumerp}</div>
                <div className="text-2xl font-bold text-primary">{t.totalCost.alumerp}</div>
                <div className="mt-2 bg-primary-100 text-primary px-3 py-1 rounded-full text-sm">
                  {currentLanguage === 'en' ? 'Best Value' : 'सबसे अच्छा मूल्य'}
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center">
                <div className="text-sm text-text-secondary mb-2">{t.competitors.competitor1}</div>
                <div className="text-2xl font-bold text-gray-900">{t.totalCost.competitor1}</div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center">
                <div className="text-sm text-text-secondary mb-2">{t.competitors.competitor2}</div>
                <div className="text-2xl font-bold text-gray-900">{t.totalCost.competitor2}</div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-lg">
              <div className="text-center">
                <div className="text-sm text-text-secondary mb-2">{t.competitors.competitor3}</div>
                <div className="text-2xl font-bold text-gray-900">{t.totalCost.competitor3}</div>
              </div>
            </div>
          </div>

          <div className="text-center mt-8">
            <div className="inline-flex items-center space-x-2 bg-success-100 text-success px-6 py-3 rounded-full">
              <Icon name="TrendingDown" size={20} color="var(--color-success)" />
              <span className="font-semibold">{t.totalCost.savings}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;